/** 动态路由状态，独立模块避免循环依赖 */
export const dynamicRouteState = {
  added: false,
  paths: [] as string[],
  /** router.addRoute 返回的移除函数，用于退出登录时真正卸载旧账号动态路由。 */
  removers: [] as Array<() => void>,
};
